export default {
    'add-new-exam': 'Add new exam',
    'edit-exam': 'Edit exam',
    'exam-link': 'Exam Link',
    'the-exam': 'the exam',
    'exam-is-added': 'Exam is added',
    'exam-is-edited': 'Exam is edited',
}